// src/context/ServicesContext.js
import React, { createContext, useState, useEffect } from "react";
import api from "../api/api";

// Create the context
export const BlogsContext = createContext();

// Create the context provider component
export const BlogsProvider = ({ children }) => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Function to fetch all services from the API
  const fetchBlogs = async () => {
    try {
      const response = await api.blogs.fetchBlogs();
      setBlogs(response);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  // Fetch blogs when the component mounts
  useEffect(() => {
    fetchBlogs();
  }, []);

  return (
    <BlogsContext.Provider value={{ blogs, loading, error }}>
      {children}
    </BlogsContext.Provider>
  );
};

